import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HttpClient } from "@angular/common/http";

import { MatButtonModule } from "@angular/material/button";
import { ToastrModule } from "ngx-toastr";
import { NgProgressModule } from "@ngx-progressbar/core";
import { NgxPermissionsModule } from "ngx-permissions";
import { TableService } from "@royalty/service/api";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { HomeComponent } from "./components/home/home.component";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

import { SharedDataService, PosFeatureService, UserSettingService } from "@royalty/service";
import { LoginDialogModule } from "@royalty/authentication/login";
import { OAuthService } from "@royalty/oauth2";
import { AuthenticationService, AuthGuard } from "@royalty/service/auth";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "src/environments/environment.prod";
import { ErrorDialogModule } from "@royalty/errordialog";
import { PermissionKeys, PERM_KEYS } from "@royalty/permissions";
import { ErrorConflictDialogModule } from "./core/error-conflict";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { DeviceDetectorModule } from "ngx-device-detector";
import { CoreModule } from "./core/core.module";
import { MobileBehaviourService } from './services/mobile.behaviour.service';
export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
	declarations: [AppComponent, HomeComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		MatButtonModule,
		HttpClientModule,
		BrowserAnimationsModule,
		ToastrModule.forRoot({
			timeOut: 4000,
			positionClass: "toast-top-full-width",
			preventDuplicates: true
		}),
		CoreModule,
		NgProgressModule,
		LoginDialogModule,
		ErrorDialogModule,
		ErrorConflictDialogModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		}),
		ServiceWorkerModule.register("ngsw-worker.js", {
			enabled: environment.production
		}),
		NgxPermissionsModule.forRoot(),
		NgIdleKeepaliveModule.forRoot(),
		DeviceDetectorModule.forRoot()
	],
	providers: [
		AuthGuard,
		AuthenticationService,
		SharedDataService,
		PosFeatureService,
		UserSettingService,
		OAuthService,
		MobileBehaviourService,
		TableService,
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				autoFocus: false,
				disableClose: true,
				restoreFocus: false,
				panelClass: "mx-2",
				minWidth: "400px"
			}
		},
		{ provide: PERM_KEYS, useValue: PermissionKeys }
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
